import { Component, OnInit, EventEmitter, Output, SimpleChanges, Input, OnChanges } from '@angular/core';
import { Subject, Observable, of, concat } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, map } from 'rxjs/operators';
import { Placeholder } from '@angular/compiler/src/i18n/i18n_ast';
import { NgOption } from '@ng-select/ng-select';

@Component({
  selector: 'app-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.scss']
})
export class FilterListComponent implements OnInit, OnChanges {
  @Output() SelectCode: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectStatus: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() Reset: EventEmitter<object> = new EventEmitter<object>();
  @Input() PlaceText;
  @Input() PlaceTextSearch;
  @Input() StatusList;
  @Input() showStatus : boolean = true;
  @Input() showSearch : boolean = true;
  selectedCode;
  selectStatus;

  constructor() { }

  ngOnInit() {
  }
  ngOnChanges() {

  }

  public onSelectChangeStatus() {
    this.SelectStatus.emit(this.selectStatus);
  }
  public onSelectChangeCode() {
    this.SelectCode.emit(this.selectedCode);
  }
  public resetList() {
    this.selectStatus = null;
    this.selectedCode = null;
    this.Reset.emit();
  }


}
